import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getSettingPhoneSLA } from "@faire/help-center-utils/settings/getSettingPhoneSLA";
import { trackHelpCenterPhoneView } from "@faire/web-api/events/helpCenter/view/phone";
import { Phone } from "@faire/web/slate/icons/foundation/Phone";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useEffect } from "react";
import { ContactUsOptionsWrapper } from "../../components/ContactUsOptionsWrapper";
import { ColumnWrapper, LeftMarginWrapper } from "../../components/EmailUs";
import { IconWrapper } from "../../components/IconWrapper";
import { OperatingTime } from "../../components/OperatingTime";
import { isPhoneInBusinessHours } from "../Phone/isPhoneInBusinessHours";
import { FormattedAvailableTime } from "./FormattedAvailableTime";
import { useFormatTime } from "./hooks/useFormatTime";
export var PhoneButton = function PhoneButton(_ref) {
  var _getRetailerToken, _getBrandToken;
  var onClick = _ref.onClick,
    _ref$disablePhone = _ref.disablePhone,
    disablePhone = _ref$disablePhone === void 0 ? false : _ref$disablePhone;
  var handleClick = function handleClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  var textColor = isPhoneInBusinessHours() && !disablePhone ? Core.text["default"] : Core.text.subdued;
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  useEffect(function () {
    trackHelpCenterPhoneView(retailerToken, brandToken);
  }, [brandToken, retailerToken]);
  var waitTime = getSettingPhoneSLA();
  var formattedWaitTime = useFormatTime(waitTime);
  if (disablePhone) {
    return /*#__PURE__*/React.createElement(ContactUsOptionsWrapper, {
      onClick: handleClick,
      disabled: true,
      dataTestId: "phone-disable-btn"
    }, /*#__PURE__*/React.createElement(ColumnWrapper, null, /*#__PURE__*/React.createElement(IconWrapper, {
      disabled: true
    }, /*#__PURE__*/React.createElement(Phone, {
      fontSize: "24"
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Spacer, {
      height: "1/2x"
    }), /*#__PURE__*/React.createElement(LeftMarginWrapper, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraphSansMedium",
      color: Core.text.subdued
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "crOSlM",
      defaultMessage: [{
        "type": 0,
        "value": "Request a call"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "labelSansRegular",
      color: Core.text.subdued
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "eHDH2d",
      defaultMessage: [{
        "type": 0,
        "value": "Phone support is currently unavailable due to site maintenance."
      }]
    })))));
  }
  return /*#__PURE__*/React.createElement(ContactUsOptionsWrapper, {
    onClick: handleClick,
    disabled: !isPhoneInBusinessHours(),
    dataTestId: "phone-btn"
  }, /*#__PURE__*/React.createElement(ColumnWrapper, null, /*#__PURE__*/React.createElement(IconWrapper, {
    disabled: !isPhoneInBusinessHours()
  }, /*#__PURE__*/React.createElement(Phone, {
    fontSize: "24"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(LeftMarginWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium",
    color: textColor
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "7BiGDS",
    defaultMessage: [{
      "type": 0,
      "value": "Request a call"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), isPhoneInBusinessHours() ? ( /*#__PURE__*/React.createElement(Typography, {
    color: textColor
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IT/yzc",
    defaultMessage: [{
      "type": 0,
      "value": "Average wait: "
    }, {
      "type": 1,
      "value": "formattedWaitTime"
    }],
    values: {
      formattedWaitTime: formattedWaitTime
    }
  }))) : ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OperatingTime, {
    color: textColor,
    supportType: "phone"
  }), /*#__PURE__*/React.createElement(FormattedAvailableTime, {
    supportType: "phone",
    color: textColor
  }))))));
};